import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Img from "gatsby-image"
import SEO from "../components/seo"
import Projects from "../components/projects"
import Atelier from "../components/atelier"
import Entreprise from "../components/entreprise"

const IndexPage = ({ data }) => (
  <Layout headerInverse={true}>
    <SEO title="Accueil" />
    <section className="section__img">
      <Img fluid={data.bgImg.childImageSharp.fluid} />
    </section>
    <section className="section__content">
      {/* <h1 className="--specialH1">Entreprise générale du bâtiment</h1> */}
      <Projects specialPadding={false} getOnlyFourItems={true} />
    </section>
    <section className="section__content">
      <Atelier getOnlyFourItems={true} />
    </section>
    <section className="section__content --pbs">
      <Entreprise />
    </section>
  </Layout>
)

export const query = graphql`
  {
    bgImg: file(relativePath: { eq: "cover-home.png" }) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`

export default IndexPage
